import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { CheckboxHeaderCellRenderer, CheckboxCellRenderer } from '../components/CellRenderers/CheckboxCellRenderer.js';

const actions = {
    init: 'init',
    markRowRange: 'markRowRange',
    selectRowRange: 'selectRowRange',
};
const reducer = (state, action) => {
    const { rowSelectionRange } = state;
    if (action.type === actions.init ||
        action.type === 'toggleAllRowsSelected' ||
        (action.id === rowSelectionRange.start &&
            action.value === false &&
            rowSelectionRange.start !== rowSelectionRange.end)) {
        return Object.assign(Object.assign({}, state), { rowSelectionRange: {
                start: null,
                end: null,
            } });
    }
    if (action.type === actions.selectRowRange) {
        return Object.assign(Object.assign({}, state), { selectedRowIds: action.rowIds, rowSelectionRange: {
                end: null,
                start: rowSelectionRange.end,
            } });
    }
    if (action.type === actions.markRowRange) {
        const { rowId, event } = action.payload;
        const shiftPressed = event.nativeEvent.shiftKey;
        if (!shiftPressed || !rowSelectionRange.start) {
            return Object.assign(Object.assign({}, state), { rowSelectionRange: {
                    start: rowId,
                    end: null,
                } });
        }
        if (shiftPressed) {
            return Object.assign(Object.assign({}, state), { rowSelectionRange: Object.assign(Object.assign({}, rowSelectionRange), { end: rowId }) });
        }
    }
    return state;
};
const useInstance = (instance) => {
    const { dispatch } = instance;
    const selectRowRange = useCallback((rowIds) => {
        dispatch({
            type: actions.selectRowRange,
            rowIds,
        });
    }, [dispatch]);
    const markRowRange = useCallback((event, rowId) => {
        dispatch({
            type: actions.markRowRange,
            payload: { rowId, event },
        });
    }, [dispatch]);
    Object.assign(instance, {
        selectRowRange,
        markRowRange,
    });
};
const prepareRow = (row, { instance }) => {
    row.markRowRange = (e) => {
        instance.markRowRange(e, row.id);
    };
};
const useCheckboxSelection = (hooks) => {
    const { dataTableOptions: { onSelectAllCheckboxChanged, onRowCheckboxChanged, enableCheckboxSelection, getCheckboxIconComponent, enableRowDragging, rtl, }, } = hooks;
    const Header = (props) => {
        return (jsx(CheckboxHeaderCellRenderer, Object.assign({ onSelectAllCheckboxChanged: onSelectAllCheckboxChanged }, (props.getToggleAllRowsSelectedProps && Object.assign({}, props.getToggleAllRowsSelectedProps())))));
    };
    const Cell = (props) => {
        const { row, state: { selectedRowIds }, } = props;
        const icon = getCheckboxIconComponent && getCheckboxIconComponent(row);
        return (jsx(CheckboxCellRenderer, Object.assign({ row: row, rtl: rtl, selectedRowIds: selectedRowIds, Icon: typeof icon === 'function' ? icon : undefined, iconName: typeof icon === 'string' ? icon : undefined, onRowCheckboxChanged: onRowCheckboxChanged, enableRowDragging: enableRowDragging && (selectedRowIds[row.id] || !Object.keys(selectedRowIds).length) }, (row.getToggleRowSelectedProps && Object.assign({}, row.getToggleRowSelectedProps())))));
    };
    hooks.stateReducers.push(reducer);
    hooks.prepareRow.push(prepareRow);
    hooks.useInstance.push(useInstance);
    hooks.visibleColumns.push(columns => {
        const isSticky = columns.some((column) => column.sticky !== undefined);
        return [
            ...(enableCheckboxSelection
                ? [
                    Object.assign({ id: 'selection', minWidth: 43, maxWidth: 43, width: 43, disableResizing: true, Header,
                        Cell }, (isSticky ? { sticky: 'left' } : {})),
                ]
                : []),
            ...columns,
        ];
    });
    hooks.visibleColumnsDeps.push((deps) => [].concat(deps, [enableCheckboxSelection, enableRowDragging]));
};

export { actions, useCheckboxSelection as default };
//# sourceMappingURL=useCheckboxSelection.js.map
